import { useQuery } from '@apollo/client';
import { transformErrors } from '@core/adapters/errors';
import { GET_LABEL_POLICY_CONTENT } from '@system-config/label-management/graphql';
import { useMemo } from 'react';

interface LabelPolicyContentResponse {
  labelPolicyContent: {
    labelId: string;
    policyFile: string;
    content: string;
    lastModified: string;
  };
}

export function useLabelPolicyContent(labelId: string, filename?: string) {
  const { data, loading, error, refetch } = useQuery<LabelPolicyContentResponse>(GET_LABEL_POLICY_CONTENT, {
    variables: { labelId, filename },
    fetchPolicy: 'cache-first',
    skip: !labelId,
  });

  const errors = useMemo(() => {
    if (!error) return undefined;

    return transformErrors(error);
  }, [error]);

  return {
    policyContent: data?.labelPolicyContent,
    loading,
    errors,
    refetch,
  };
}
